import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import classnames from "classnames";
import { useStyles } from "./Reactions.styles.js";
const ThumbsUp = (t0)=>{
    const $ = c(56);
    const { size: t1, color: t2 } = t0;
    const size = void 0 === t1 ? "default" : t1;
    const color = void 0 === t2 ? "secondary" : t2;
    const { classes } = useStyles();
    const t3 = classes[`icon_size_${size}`];
    const t4 = classes[`icon_color_${color}`];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = classnames(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M10.193 17.2551C6.74257 17.2551 4.95703 15.9946 4.47968 13.4371C3.91132 10.611 5.94531 8.38205 6.74257 7.70315C7.58554 6.98557 8.37538 5.85471 8.29179 4.04729C8.18906 1.82228 10.5508 1.50002 11.2668 3.58479C11.8715 5.34533 10.4777 7.57307 11.3531 8.5051C11.6666 8.80502 12.5484 8.89857 12.5484 8.89857C12.9714 8.95906 13.7046 8.97082 13.9724 8.97884C15.7248 9.35375 14.428 10.4241 14.5043 11.3699C14.8691 12.5641 15.0538 17.2551 10.193 17.2551Z",
            fill: "url(#paint0_radial_4706_230590)"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            opacity: "0.7",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.7465 7.6998C7.58799 6.98205 8.37525 5.8519 8.29179 4.04729C8.18906 1.82228 10.5508 1.50002 11.2668 3.58479C11.56 4.43856 11.3833 5.4022 11.2233 6.27466C11.0549 7.19253 10.9051 8.00948 11.3405 8.4914C11.3449 8.49595 11.3492 8.50051 11.3535 8.50507C11.952 9.14247 12.0604 9.40176 12.0534 9.4957C12.1159 9.48307 12.2393 9.48091 12.468 9.51445C14.4561 9.80541 14.4661 10.1898 14.4864 10.9684C14.4896 11.092 14.493 11.2254 14.5047 11.3699C14.8695 12.5641 15.1167 17.2551 10.1934 17.2551H10.193C6.74257 17.2551 4.95703 15.9945 4.47968 13.4371C3.91132 10.6109 5.94531 8.38203 6.74257 7.70312C6.74388 7.70201 6.74519 7.7009 6.7465 7.6998Z",
            fill: "url(#paint1_radial_4706_230590)"
        });
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    let t25;
    let t26;
    let t27;
    let t28;
    let t29;
    let t30;
    let t8;
    let t9;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_f_4706_230590)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M5.68164 12.989C10.0695 13.2558 8.16758 16.7683 11.0359 16.2683C11.7742 16.1394 11.7922 10.4554 11.7723 9.3503C10.5047 9.06124 10.8328 9.94092 10.8328 9.94092C10.8328 9.94092 10.0152 12.8468 5.68164 12.9894V12.989Z",
                fill: "url(#paint2_radial_4706_230590)"
            })
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M8.09454 15.3782C7.89376 16.4469 8.72384 17.2219 9.80782 17.1336C11.0754 17.0305 11.7637 17.1739 11.9645 16.1051C12.1652 15.0364 11.4617 14.0075 10.393 13.8067C9.32423 13.6059 8.29532 14.3094 8.09454 15.3782Z",
            fill: "url(#paint3_radial_4706_230590)"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z",
            fill: "url(#paint4_radial_4706_230590)"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z",
            fill: "url(#paint5_radial_4706_230590)"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z",
            fill: "url(#paint6_radial_4706_230590)"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z",
            fill: "url(#paint7_radial_4706_230590)"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M10.0293 15.9258C11.1166 15.9258 11.998 15.0443 11.998 13.957C11.998 12.8697 11.1166 11.9883 10.0293 11.9883C8.94199 11.9883 8.06055 12.8697 8.06055 13.957C8.06055 15.0443 8.94199 15.9258 10.0293 15.9258Z",
            fill: "url(#paint8_radial_4706_230590)"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z",
            fill: "url(#paint9_radial_4706_230590)"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z",
            fill: "url(#paint10_radial_4706_230590)"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z",
            fill: "url(#paint11_radial_4706_230590)"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z",
            fill: "url(#paint12_radial_4706_230590)"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z",
            fill: "url(#paint13_radial_4706_230590)"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z",
            fill: "url(#paint14_radial_4706_230590)",
            fillOpacity: "0.7"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z",
            fill: "url(#paint15_radial_4706_230590)",
            fillOpacity: "0.4"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            opacity: "0.7",
            d: "M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z",
            fill: "url(#paint16_radial_4706_230590)",
            fillOpacity: "0.8"
        });
        t23 = /*#__PURE__*/ jsx("path", {
            d: "M10.3672 12.3086C11.4545 12.3086 12.3359 11.4272 12.3359 10.3398C12.3359 9.25253 11.4545 8.37109 10.3672 8.37109C9.27988 8.37109 8.39844 9.25253 8.39844 10.3398C8.39844 11.4272 9.27988 12.3086 10.3672 12.3086Z",
            fill: "url(#paint17_radial_4706_230590)"
        });
        t24 = /*#__PURE__*/ jsx("path", {
            d: "M9.80762 14.0586C10.8949 14.0586 11.7764 13.1772 11.7764 12.0898C11.7764 11.0025 10.8949 10.1211 9.80762 10.1211C8.72031 10.1211 7.83887 11.0025 7.83887 12.0898C7.83887 13.1772 8.72031 14.0586 9.80762 14.0586Z",
            fill: "url(#paint18_radial_4706_230590)"
        });
        t25 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z",
            fill: "url(#paint19_radial_4706_230590)"
        });
        t26 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z",
            fill: "url(#paint20_radial_4706_230590)"
        });
        t27 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z",
            fill: "url(#paint21_radial_4706_230590)"
        });
        t28 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z",
            fill: "url(#paint22_radial_4706_230590)"
        });
        t29 = /*#__PURE__*/ jsx("path", {
            d: "M11.1526 9.21806C9.75139 9.33885 9.3401 10.8579 10.7273 11.369C12.3968 11.9842 14.3499 11.7278 15.2582 11.3551C16.196 10.9704 16.324 9.38253 15.1643 9.02158C14.5241 8.82206 13.7546 9.02156 12.9349 9.09966C12.2144 9.16833 11.7536 9.16626 11.1526 9.21806Z",
            fill: "url(#paint23_radial_4706_230590)"
        });
        t30 = /*#__PURE__*/ jsx("path", {
            d: "M10.9786 9.24559C9.85384 9.34003 9.31932 10.7795 10.7271 11.3692C12.3966 11.9843 14.3497 11.7279 15.2579 11.3553C16.1958 10.9705 16.3238 9.37337 15.164 9.01242C14.5477 8.82034 13.7977 8.98057 13.0124 9.0905C12.3228 9.15723 11.535 9.15857 10.9786 9.24559Z",
            fill: "url(#paint24_radial_4706_230590)"
        });
        $[5] = t10;
        $[6] = t11;
        $[7] = t12;
        $[8] = t13;
        $[9] = t14;
        $[10] = t15;
        $[11] = t16;
        $[12] = t17;
        $[13] = t18;
        $[14] = t19;
        $[15] = t20;
        $[16] = t21;
        $[17] = t22;
        $[18] = t23;
        $[19] = t24;
        $[20] = t25;
        $[21] = t26;
        $[22] = t27;
        $[23] = t28;
        $[24] = t29;
        $[25] = t30;
        $[26] = t8;
        $[27] = t9;
    } else {
        t10 = $[5];
        t11 = $[6];
        t12 = $[7];
        t13 = $[8];
        t14 = $[9];
        t15 = $[10];
        t16 = $[11];
        t17 = $[12];
        t18 = $[13];
        t19 = $[14];
        t20 = $[15];
        t21 = $[16];
        t22 = $[17];
        t23 = $[18];
        t24 = $[19];
        t25 = $[20];
        t26 = $[21];
        t27 = $[22];
        t28 = $[23];
        t29 = $[24];
        t30 = $[25];
        t8 = $[26];
        t9 = $[27];
    }
    let t31;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_4706_230590",
            x: "5.4082",
            y: "9.01855",
            width: "6.6416",
            height: "7.57227",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.136719",
                    result: "effect1_foregroundBlur_4706_230590"
                })
            ]
        });
        $[28] = t31;
    } else t31 = $[28];
    let t32;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.7215 3.51213) scale(14.3293)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFB100"
                })
            ]
        });
        $[29] = t32;
    } else t32 = $[29];
    let t33;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.4649 11.796) rotate(-160.304) scale(7.1343 10.8298)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.564882",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.85"
                })
            ]
        });
        $[30] = t33;
    } else t33 = $[30];
    let t34;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.9823 13.0706) rotate(178.409) scale(4.42237 5.48846)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.154202",
                    stopColor: "#C62400",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[31] = t34;
    } else t34 = $[31];
    let t35;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.1101 15.5812) rotate(-12.8877) scale(1.80892)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#A80000"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[32] = t35;
    } else t35 = $[32];
    let t36;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.4441 15.7775) rotate(-178.53) scale(3.60816 1.60209)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[33] = t36;
    } else t36 = $[33];
    let t37;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t37 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.8888 15.1686) rotate(173.738) scale(3.79489 1.3501)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.369792",
                    stopColor: "#DA4E00",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE918",
                    stopOpacity: "0"
                })
            ]
        });
        $[34] = t37;
    } else t37 = $[34];
    let t38;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t38 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint6_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.2216 15.2703) rotate(-177.163) scale(3.30407 1.5915)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#F76D42"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B701",
                    stopOpacity: "0"
                })
            ]
        });
        $[35] = t38;
    } else t38 = $[35];
    let t39;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t39 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint7_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.6134 15.1206) scale(4.42617 4.14385)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.79",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.99",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.4"
                })
            ]
        });
        $[36] = t39;
    } else t39 = $[36];
    let t40;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t40 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint8_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.0407 13.8467) rotate(10.64) scale(2.08594)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#A80000"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[37] = t40;
    } else t40 = $[37];
    let t41;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t41 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint9_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(14.0107 14.1163) rotate(-179.036) scale(4.46632 2.00717)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[38] = t41;
    } else t41 = $[38];
    let t42;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t42 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint10_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.1542 13.2507) rotate(175.625) scale(4.2552 1.51385)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.44",
                    stopColor: "#DA4E00",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE918",
                    stopOpacity: "0"
                })
            ]
        });
        $[39] = t42;
    } else t42 = $[39];
    let t43;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t43 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint11_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.0817 13.2178) rotate(175.362) scale(3.29965 1.44617)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#F76D42"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B701",
                    stopOpacity: "0"
                })
            ]
        });
        $[40] = t43;
    } else t43 = $[40];
    let t44;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t44 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint12_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.2348 13.0813) scale(4.69687 4.39729)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.79",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.99",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.4"
                })
            ]
        });
        $[41] = t44;
    } else t44 = $[41];
    let t45;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t45 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint13_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(1.10904 6.14644) rotate(3.76058) scale(10.5241 17.2596)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.812811",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.959491",
                    stopColor: "#FF9C1F",
                    stopOpacity: "0.8"
                })
            ]
        });
        $[42] = t45;
    } else t45 = $[42];
    let t46;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t46 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint14_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.71248 5.89161) rotate(11.5806) scale(2.55984 4.45677)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF8E00",
                    stopOpacity: "0.9"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[43] = t46;
    } else t46 = $[43];
    let t47;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t47 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint15_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.9725 7.30992) rotate(40.4094) scale(1.99766 2.74871)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF8E00",
                    stopOpacity: "0.9"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[44] = t47;
    } else t47 = $[44];
    let t48;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t48 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint16_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.49311 8.60657) rotate(-9.90436) scale(6.91024 9.84462)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.315291",
                    stopColor: "#FFC42E",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.846569",
                    stopColor: "#FF7DBE"
                })
            ]
        });
        $[45] = t48;
    } else t48 = $[45];
    let t49;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t49 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint17_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.5161 10.2673) rotate(10.2996) scale(1.94367)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#BA4E00"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[46] = t49;
    } else t49 = $[46];
    let t50;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t50 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint18_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.8188 11.9796) rotate(10.64) scale(2.08594)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#A81E00"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[47] = t50;
    } else t50 = $[47];
    let t51;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t51 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint19_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.9446 12.4781) rotate(-177.687) scale(4.54194 2.31243)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[48] = t51;
    } else t51 = $[48];
    let t52;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t52 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint20_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.0145 11.047) rotate(172.737) scale(3.94235 1.6129)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.44",
                    stopColor: "#DA4E00",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE918",
                    stopOpacity: "0"
                })
            ]
        });
        $[49] = t52;
    } else t52 = $[49];
    let t53;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t53 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint21_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.3224 11.3391) rotate(175.673) scale(3.62978 1.48502)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#F76D42"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B701",
                    stopOpacity: "0"
                })
            ]
        });
        $[50] = t53;
    } else t53 = $[50];
    let t54;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t54 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint22_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.9475 11.0767) scale(4.56289 4.27185)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.79",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.99",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.4"
                })
            ]
        });
        $[51] = t54;
    } else t54 = $[51];
    let t55;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t55 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint23_radial_4706_230590",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(14.5227 10.1333) rotate(-178.53) scale(4.624 2.29462)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[52] = t55;
    } else t55 = $[52];
    let t56;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
        t56 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t31,
                t32,
                t33,
                t34,
                t35,
                t36,
                t37,
                t38,
                t39,
                t40,
                t41,
                t42,
                t43,
                t44,
                t45,
                t46,
                t47,
                t48,
                t49,
                t50,
                t51,
                t52,
                t53,
                t54,
                t55,
                /*#__PURE__*/ jsxs("radialGradient", {
                    id: "paint24_radial_4706_230590",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(11.2044 9.51577) scale(4.87656 4.56552)",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            offset: "0.79",
                            stopColor: "#FFD400",
                            stopOpacity: "0"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: "0.99",
                            stopColor: "#FF8E00",
                            stopOpacity: "0.4"
                        })
                    ]
                })
            ]
        });
        $[53] = t56;
    } else t56 = $[53];
    let t57;
    if ($[54] !== t5) {
        t57 = /*#__PURE__*/ jsxs(SvgIcon, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: t5,
            children: [
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t25,
                t26,
                t27,
                t28,
                t29,
                t30,
                t56
            ]
        });
        $[54] = t5;
        $[55] = t57;
    } else t57 = $[55];
    return t57;
};
export { ThumbsUp };
